import { render } from "./StaticAndFinanceBlock.vue?vue&type=template&id=75e15bbd&scoped=true"
import script from "./StaticAndFinanceBlock.vue?vue&type=script&lang=js"
export * from "./StaticAndFinanceBlock.vue?vue&type=script&lang=js"

import "./StaticAndFinanceBlock.vue?vue&type=style&index=0&id=75e15bbd&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/sparta-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75e15bbd"]])

export default __exports__